/**
 * Overlay-specific colors for signing field recipient indicators.
 * These are intentionally raw hex values — they need to work with
 * CSS opacity suffixes (e.g., `${color}18` for backgrounds) in the
 * PdfViewer field overlay layer. They are not mapped to design tokens
 * because they serve a distinct visual purpose (multi-signer
 * differentiation on a PDF canvas) separate from the UI theme.
 */
export const RECIPIENT_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];
